import axios from '../plugins/axios';

const COMMON_REQUEST_HEADER = {
  'Content-Type': 'application/json',
};

export default {
  getPrivacyDoc(id) {
    const url = process.env.VUE_APP_HIWORKS_LINK_API + `/policies/privacy/terms/links/${id}`;
    const options = {
      headers: COMMON_REQUEST_HEADER,
    };

    return axios.get(url, options);
  },

  getPrivacyAgreement(id) {
    const url = process.env.VUE_APP_HIWORKS_LINK_API + `/policies/privacy/agreements/links/${id}`;
    const options = {
      headers: COMMON_REQUEST_HEADER,
    };

    return axios.get(url, options);
  },

  acceptPrivacy(data) {
    const url = process.env.VUE_APP_HIWORKS_LINK_API + `/policies/privacy/agreements`;

    const options = {
      headers: COMMON_REQUEST_HEADER,
    };

    return axios.post(url, data, options);
  },
};
